export const isItemMatchingType = <
    Item extends {
        rule: { ruleType: string };
        rewards: Array<{ rewardType: string }>;
    },
    RuleType extends Item["rule"]["ruleType"],
    RewardType extends Item["rewards"][number]["rewardType"]
>(
    item: Item,
    ruleType: RuleType,
    rewardType: RewardType
): item is Item & {
    rule: Item["rule"] & { ruleType: RuleType };
    rewards: [Extract<Item["rewards"][number], { rewardType: RewardType }>];
} =>
    item.rule.ruleType === ruleType &&
    item.rewards[0].rewardType === rewardType;
